"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconComponent = _interopRequireDefault(require("./utils/IconComponent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function LocationBlue(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react["default"].createElement(_IconComponent["default"], _extends({
    name: "location-blue",
    size: "".concat(size),
    viewboxSize: "13"
  }, props), _react["default"].createElement("g", null, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: ".95"
  }, _react["default"].createElement("path", {
    d: "M-3-1h19v19H-3z"
  }), _react["default"].createElement("path", {
    fill: "#0E247D",
    fillRule: "nonzero",
    d: "M6.5 8.5c-.87 0-1.583-.713-1.583-1.583 0-.871.712-1.584 1.583-1.584.87 0 1.583.713 1.583 1.584 0 .87-.712 1.583-1.583 1.583zm4.75-1.425c0-2.874-2.098-4.908-4.75-4.908S1.75 4.2 1.75 7.075c0 1.853 1.544 4.307 4.75 7.236 3.206-2.93 4.75-5.383 4.75-7.236zM6.5.583c3.325 0 6.333 2.55 6.333 6.492 0 2.628-2.113 5.74-6.333 9.342C2.28 12.815.167 9.703.167 7.075.167 3.133 3.175.583 6.5.583z"
  }))));
}

LocationBlue.defaultProps = {
  size: 30
};
var _default = LocationBlue;
exports["default"] = _default;